import { createLogic } from 'redux-logic';
import { stopSubmit } from 'redux-form';
import { PROFILE_UPDATE_ACCOUNT_PENDING, LIFEWAY_ACCOUNTS_URL, PATH_PROFILE } from '../constants';
import {
  updateEmailSuccess, updateEmailError, updatePasswordSuccess, updatePasswordError, setBannerState
} from '../actions/AppActions';
import history from '../utils/history';

export const updateAccountLogic = createLogic({
  type: PROFILE_UPDATE_ACCOUNT_PENDING,
  latest: true,

  validate({ getState, action }, allow, reject) {
    const state = getState();
    const frm = state.form[action.payload.form];
    const isEmail = action.payload.form === 'emailForm';
    // no change was made to the account information
    if (isEmail && frm.initial.email === action.payload.email || !isEmail && frm.initial.password === action.payload.password) {
      reject(stopSubmit(action.payload.form, {}));
    } else {
      allow(action);
    }
  },

  processOptions: {
    dispatchMultiple: true
  },

  process({ httpClient, action, getState }, dispatch) {
    const http = httpClient(dispatch);
    let isPassword;
    const requests = [];
    const state = getState();
    const frm = state.form[action.payload.form];
    const isEmail = action.payload.form === 'emailForm';
    const intl = state.intl.messages;

    if (isEmail && action.payload.email !== frm.initial.email) {

      const emailData = { newEmail: action.payload.email };
      const updateEmail = http.put(`${LIFEWAY_ACCOUNTS_URL}/api/user/profile/updateUsername`, emailData);
      requests.push(updateEmail);

    }
    if (!isEmail && action.payload.password !== 'password') {

      const passwordData = { password: action.payload.password };
      const updatePassword = http.put(`${LIFEWAY_ACCOUNTS_URL}/api/user/profile/updatePassword`, passwordData);
      requests.push(updatePassword);

    }

    return Promise.all(requests)
      .then(values => {
        values.forEach(resp => {
          isPassword = resp?.config.url.toLowerCase().indexOf('password') > -1;

          if (isPassword) {
            // updated password
            dispatch(updatePasswordSuccess());
          } else {
           // update email
            dispatch(updateEmailSuccess(action.payload.email));
          }
        });
        // stop form submission
        dispatch(stopSubmit(action.payload.form));
        // close the form
        history.push(PATH_PROFILE);

        const bannerState = {
          data: {
            type: 'success',
            message: intl.Success.Account[isEmail ? 'Update_Email_Success' : 'Update_Password_Success']
          }
        };
        dispatch(setBannerState(bannerState));

        return values;

      }).catch(({ response }) => {
        isPassword = response?.config?.url.toLowerCase().indexOf('password') > -1;
        const errors = { email: null, password: null };
        const error = {};

        const errType = isPassword ? 'password' : 'email';
        errors[(status === 504) ? 'timeout' : errType] = response;

        if (errors.password) {
          error.password = true;
          dispatch(updatePasswordError(errors.password));
        }

        if (errors.email) {
          error.email = true;
          if (errors.email.data.code === 'lifewayaccount.usernamealreadyexists.error') {
            error.email = intl.Errors.Account.Username_Exists;
          }
          dispatch(updateEmailError(errors.email));
        }

        if ((errors.password && errors.email) || errors.timeout) {
          error._error = intl.Errors.Account.Update_Failed;
        } else {
          isPassword = Boolean(errors.password);
          const errType = errors[isPassword ? 'password' : 'email'];

          // gateway errors
          if (errType && errType.status >= 500) error._errors = intl.Errors.Account[`Update_${isPassword ? 'Password' : 'Email'}_Error`];
        }

        dispatch(stopSubmit(action.payload.form, error));

        return errors;
      });
  }
});

export default [
  updateAccountLogic
];
